module.exports = __webpack_public_path__ + "img/border.825186f3.gif";